import * as React from 'react';

import styles from './DeletedMessageLayout.css';
import { EMessageType } from '../../types/messageType';
import { EUserColor } from '../../types/userName';
import { ChatMessageBubble } from '../ChatMessageBubble';
import { ChatMessage } from '../ChatMessage';
import { Body1 } from '@cian/ui-kit';
import { IconActionBlock16 } from '@cian/ui-kit-design-tokens/icons';

interface IDeletedMessageLayoutProps {
  messageType: EMessageType;
  isLastMessageInChain: boolean;
  messageMeta: React.ReactNode;
  userColor?: EUserColor;
  userName?: React.ReactNode;
  deletedMessage: React.ReactNode;
  highlighted?: boolean;
  onHighlightEnd?: VoidFunction;
}

export const DeletedMessageLayout = React.forwardRef<HTMLDivElement, IDeletedMessageLayoutProps>(
  function DeletedMessageLayout(
    {
      messageType,
      isLastMessageInChain,
      messageMeta,
      userColor,
      userName,
      deletedMessage,
      highlighted,
      onHighlightEnd,
    },
    ref,
  ) {
    return (
      <ChatMessage dataName="DeletedMessageLayout">
        <ChatMessageBubble
          messageType={messageType}
          withTail={isLastMessageInChain}
          className={styles['bubble']}
          ref={ref}
          userColor={userColor}
          highlighted={highlighted}
          onHighlightEnd={onHighlightEnd}
        >
          <div className={styles['layout']}>
            <div className={styles['content-wrapper']}>
              {userName}
              <div className={styles['content']}>
                <IconActionBlock16 color="icon-inverted-disabled" />
                <Body1 color="text-inverted-disabled">{deletedMessage}</Body1>
              </div>
            </div>
            <div className={styles['meta']}>{messageMeta}</div>
          </div>
        </ChatMessageBubble>
      </ChatMessage>
    );
  },
);
